<template>
  <span
    :class="['field-item', active ? 'active' : '']"
    @click="$emit('click')">
    {{ value }}
  </span>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: () => false,
    },
  },
});
</script>

<style lang="scss">
  .field-item {
    color: #4da7ff;
    display: inline-block;
    border: 1px solid #4da7ff;
    margin: 3px;
    padding: 5px 8px;
    border-radius: 10px;
    cursor: pointer;
    user-select: none;

    &.active {
      background: #e7f1ff;
    }
  }
</style>
